import { render, staticRenderFns } from "./Rotulo.vue?vue&type=template&id=07a7057c&scoped=true&"
import script from "./Rotulo.vue?vue&type=script&lang=js&"
export * from "./Rotulo.vue?vue&type=script&lang=js&"
import style0 from "./Rotulo.vue?vue&type=style&index=0&id=07a7057c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7057c",
  null
  
)

export default component.exports